<template>
  <div class="page-container home-inspector representation-container">
    <section class="representation-content">
      <article>
        <div v-if="isShowingRate" class="row justify-content-md-center pt-4">
          <div class="col-md-8 mb-3 mt-3">
            <span class="text-center proposal-title" for="">
              <strong>Premium Proposal for: </strong> <span class=" blue-color">{{quickQuote.nameOfFirm}}</span>
            </span>
          </div>
          <div class="col-md-8 mb-3">
            <span class="col-md-4 text-center proposal-title pl-0 pr-0" for="">
              <strong>Limits of Coverage: </strong>
            <span class=" blue-color">
            {{coverages[quickQuote.coverage].limitOfCoverage}}
            </span>
            </span>
          </div>
          <div class="col-md-8">
            <span class="col-md-3 text-center proposal-title pl-0" for="">
              <strong>Deductible: </strong>
            </span>
            <strong style="font-size: 23px;"  v-if="deductibleAmount" >$1,500</strong>
            <strong style="font-size: 23px;" v-if="!deductibleAmount" >$2,500</strong>
          </div>
        </div>
        <div v-if="isShowingRate" class="row pt-5 mb-5">
          <h3 class="text-center font-weight-bold mx-auto">
            This Indication includes E&O and General Liability in ONE Policy:
          </h3>
        </div>
        <div v-if="isShowingRate" class="row mr-0 ml-0">
          <div class="col-md-7">
            <div class="text-center pull-left ml-0">
              <p v-if="quickQuote.cyberCoverage" class="mr-0 representation-price-font-active" >{{ coverages[quickQuote.coverage].downCyberTotal }}</p>
              <p v-else class="mr-0 representation-price-font-active">{{ coverages[quickQuote.coverage].downTotal }}</p><span style="font-size:19px;position:relative;top:-12px;" class="blue-color">Down Payment</span>
              <br><span style="top:-22px;position:relative;font-size: 11px;" class="blue-color">Finance Your Policy - Finance Charge Applies</span>
            </div>
<!--            <button v-if="(this.quickQuote.customer.state === 'AR' || this.quickQuote.customer.state === 'CA' || this.quickQuote.customer.state === 'FL'-->
<!--            || this.quickQuote.customer.state === 'ND' || this.quickQuote.customer.state === 'WV' || this.quickQuote.customer.state === 'WY'-->
<!--            || this.quickQuote.customer.state === 'KS' || this.quickQuote.customer.state === 'NJ' || this.quickQuote.customer.state === 'NE'-->
<!--            || this.quickQuote.customer.state === 'WA' || this.quickQuote.customer.state === 'CT' || this.quickQuote.customer.state === 'MA'-->
<!--            || this.quickQuote.customer.state === 'OH' || this.quickQuote.customer.state === 'NY') && state.submittedSlDisclosure === false" class="pull-right text-center pay-now"-->
<!--                    @click="formSubmit()">PAY NOW</button>-->

<!--            <a v-else v-bind:href="'https://orep.org/financeunited150/index.php?name='+quickQuote.nameOfPrincipalHomeInspector+'&ia_name='+quickQuote.nameOfFirm+'&address='+encodeURIComponent(quickQuote.customer.address)+'&city='+quickQuote.customer.city+'&state_code='+quickQuote.customer.state+'&zip='+quickQuote.customer.zipCode+'&phone='+quickQuote.customer.phone+'&email='+quickQuote.customer.email+'&date='+formattedCurrentDate()+'&premium='+total(coverages).toFixed(2)"-->
<!--               target="_blank"-->
<!--               class="pull-right text-center pay-now_2">PAY NOW</a>-->
          </div>
          <div class="col-md-5 quote-includes-btn-wrapper flex align-items-center justify-content-md-center">
            <button
                class="orep-select quote-include"
                name="state"
                v-validate="'required'"
            >
              Quote Includes
            </button>
          </div>
        </div>
        <div v-if="isShowingRate" class="row quote-action quote-include-action-wrapper input-section mr-0 ml-0">
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title">E&O/GL PREMIUM:</span>
                <span v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberPremium }}</span>
                <span v-else >{{ coverages[quickQuote.coverage].premium }}</span>
              </li>
              <li>
                <span class="title"> {{ this.quickQuote.customer.state }} SL TAX:</span><span v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberSurplusLineTax }}</span>
                <span v-else >{{ coverages[quickQuote.coverage].surplusLineTax }}</span>
              </li>
              <li>
                <span class="title"> {{ this.quickQuote.customer.state }} SL STAMPING FEE:</span> <span v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberStampingFee }}</span>
                <span v-else >{{ coverages[quickQuote.coverage].stampingFee }}</span>
              </li>
              <li>
                <span class="title">OREP MEMBER FEE: </span>
                <span>{{ coverages[quickQuote.coverage].orepFee }}</span>
              </li>
              <li>
                <span class="title">ADDITIONAL STATE FEE:</span>
                <span v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberExtraFee }} </span>
                <span v-else >{{ coverages[quickQuote.coverage].extraFee }} </span>
              </li>
              <li class="total">
                <span class="title">TOTAL DUE:</span>
                <h5 class="font-weight-bold m-0" v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberTotal }}</h5>
                <h5 class="font-weight-bold m-0" v-else>{{ coverages[quickQuote.coverage].total }}</h5>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title_1">{{ coverages[quickQuote.coverage].orepClaim }} Personal Injury Coverage</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quickQuote.coverage].orepClaim }} General Liability Coverage(Per Claim)</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quickQuote.coverage].orepClaim }} Professional Liability -  Each Claim</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quickQuote.coverage].orepClaim }} Professional Liability - Aggregate Limit </span>
              </li>
              <li>
                <span class="title_1">$25,000 Disciplinary Proceedings</span>
              </li>
              <li>
                <span class="title_1">$5,000 Loss of Earnings</span>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="isShowingRate" class="row mr-0 ml-0 text-center" style="border:1px solid #ccc">
          <div class="col-md-7">
            <div class="text-center money-text pull-left representation-price-font">
              <p class="representation-price-font-disable" v-if="quickQuote.cyberCoverage">{{ coverages[quickQuote.coverage].cyberTotal }}</p>
              <p class="representation-price-font-disable" v-else>{{ coverages[quickQuote.coverage].total }}</p>
              <p class="blue-color mb-0">Total - Pay in Full</p>
            </div>
<!--            <button v-if="(this.quickQuote.customer.state === 'AR' || this.quickQuote.customer.state === 'CA' || this.quickQuote.customer.state === 'FL'-->
<!--            || this.quickQuote.customer.state === 'ND' || this.quickQuote.customer.state === 'WV' || this.quickQuote.customer.state === 'WY'-->
<!--            || this.quickQuote.customer.state === 'KS' || this.quickQuote.customer.state === 'NJ' || this.quickQuote.customer.state === 'NE'-->
<!--            || this.quickQuote.customer.state === 'WA' || this.quickQuote.customer.state === 'CT' || this.quickQuote.customer.state === 'MA'-->
<!--            || this.quickQuote.customer.state === 'OH' || this.quickQuote.customer.state === 'NY') && state.submittedSlDisclosure === false"-->
<!--                    class="pull-right pay-now_3"-->
<!--                    @click="formSubmit()">PAY NOW</button>-->
<!--            <button v-else-->
<!--                    class="pull-right pay-now_3"-->
<!--                    @click="navigateToNext('property-inspector-payment')">PAY NOW</button>-->
          </div>
          <div class="col-md-5 quote-includes-btn-wrapper flex align-items-center justify-content-md-center">
            <button
                class="orep-select quote-include_1"
                name="state"
                v-validate="'required'"
            >
              Quote Includes
            </button>
          </div>
        </div>
        <div v-if="isShowingRate" class="row quote-action quote-include_1-action-wrapper input-section mr-0 ml-0">
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title">E&O/GL PREMIUM:</span>
                <span v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberPremium }}</span>
                <span v-else >{{ coverages[quickQuote.coverage].premium }}</span>
              </li>
              <li>
                <span class="title"> {{ this.quickQuote.customer.state }} SL TAX:</span><span v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberSurplusLineTax }}</span>
                <span v-else >{{ coverages[quickQuote.coverage].surplusLineTax }}</span>
              </li>
              <li>
                <span class="title"> {{ this.quickQuote.customer.state }} SL STAMPING FEE:</span> <span v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberStampingFee }}</span>
                <span v-else >{{ coverages[quickQuote.coverage].stampingFee }}</span>
              </li>
              <li>
                <span class="title">OREP MEMBER FEE: </span>
                <span>{{ coverages[quickQuote.coverage].orepFee }}</span>
              </li>
              <li>
                <span class="title">ADDITIONAL STATE FEE:</span>
                <span v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberExtraFee }} </span>
                <span v-else >{{ coverages[quickQuote.coverage].extraFee }} </span>
              </li>
              <li class="total">
                <span class="title">TOTAL DUE:</span>
                <h5 class="font-weight-bold m-0" v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberTotal }}</h5>
                <h5 class="font-weight-bold m-0" v-else>{{ coverages[quickQuote.coverage].total }}</h5>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title_1">{{ coverages[quickQuote.coverage].orepClaim }} Personal Injury Coverage</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quickQuote.coverage].orepClaim }} General Liability Coverage(Per Claim)</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quickQuote.coverage].orepClaim }} Professional Liability -  Each Claim</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quickQuote.coverage].orepClaim }} Professional Liability - Aggregate Limit </span>
              </li>
              <li>
                <span class="title_1">$25,000 Disciplinary Proceedings</span>
              </li>
              <li>
                <span class="title_1">$5,000 Loss of Earnings</span>
              </li>
            </ul>
          </div>
        </div>
        <label v-else for="" class="text-justify" style="font-size: 25px">
          Thank you for submitting your application. Based on one or more answers, your application will need to be reviewed by an underwriter before we can present you with a premium proposal. Someone from OREP will reach out to you via email or phone within two business days. Thank you for shopping OREP!
        </label>
      </article>
      <article class="text-section table-section mt-5">
        <label style="font-size: 23px; padding-bottom: 20px">
          This Premium Indication is subject to completion of a full application and underwriting approval.
        </label>
        <label for="" class="text-center font-weight-bold">
          Most Programs Do Not <em><strong>Specialize</strong></em> in Home Inspector Insurance and Defense. <span style="color:#A81508">We Do</span>. It Matters.
        </label>
        <div class="table-responsive">
          <table class="table-bordered mt-4 ">
            <thead>
            <th v-if="getApplicantType === 'spmga'" width="60%" class="text-center font-weight-bold">Why Choose Southern Preferred?</th>
            <th v-else width="60%" class="text-center font-weight-bold">Why Choose OREP?</th>
            <th v-if="getApplicantType === 'spmga'" width="20%" class="text-center font-weight-bold">Included with SPMGA</th>
            <th v-else width="20%" class="text-center font-weight-bold">Included with OREP</th>
            <th width="20%" class="text-center font-weight-bold">The Other Guys</th>
            </thead>
            <tbody>
            <tr>
              <td>
                <label for="" class="red-text mb">
                  Attorney Led Pre-Claims Support
                </label>
                <label for="" class="table-text">
                  Trial attorney Geoff Binney, with over a decade of experience defending inspectors, provides pre-claims support and decisive response letters to shut down frivolous claims. Don’t leave your financial future in the hands of a claims adjuster who doesn’t know your business.
                </label>
              </td>
              <td>
                <div>
                  <img src="../../../public/assets/images/shield1.png">
                </div>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <label for="" class="red-text">
                  Business Building Benefits
                </label>
                <label for="" class="table-text">
                  OREP Members enjoy Free Training Webinars on marketing, risk management, and liability, as well as access to InspectorAdvisor.com, where they can get their questions answered by an experienced expert. And much more!                  </label>
              </td>
              <td>
                <div>
                  <img src="../../../public/assets/images/shield1.png">
                </div>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <label for="" class="red-text">
                  Over 20 Years Defending Home Inspectors
                </label>
                <label for="" class="table-text">
                  We’ve been insuring and defending home inspectors for decades. Were’ not just a passing fad.
                </label>
              </td>
              <td>
                <div>
                  <img src="../../../public/assets/images/shield1.png">
                </div>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <label for="" class="red-text">
                  Guaranteed Delivery of Working RE Home Inspector
                </label>
                <label for="" class="table-text">
                  Stay informed and “in-the-know” with a subscription to the most widely read trade publication in the home inspection profession.
                </label>
              </td>
              <td>
                <div>
                  <img src="../../../public/assets/images/shield1.png">
                </div>
              </td>
              <td class="text-center">
              </td>
            </tr>
            <tr>
              <td>
                <label for="" class="red-text">
                  Coverage Designed Specifically for Home Inspectors
                </label>
                <label for="" class="table-text">
                  Your coverage needs are NOT generic. OREP’s policy is designed specifically for home inspectors and includes coverage for Mold, Termite/WDO, Infrared, Pool/Spa, Drones, Carbon Monoxide, and much more!
                </label>
              </td>
              <td>
                <div>
                  <img src="../../../public/assets/images/shield1.png">
                </div>
              </td>
              <td class="text-center">
                <label class="text-center"  for="">
                  Sometimes
                </label>
              </td>
            </tr>
            <tr>
              <td>
                <label for="" class="red-text">
                  Policy Includes E&O and General Liability Coverage in a Single Policy
                </label>
              </td>
              <td>
                <div>
                  <img src="../../../public/assets/images/shield1.png">
                </div>
              </td>
              <td class="text-center">
                <label class="text-center"  for="">
                  Rarely
                </label>
              </td>
            </tr>
            <tr>
              <td>
                <label for="" class="red-text">
                  Mold Coverage Included in Base Policy at no charge
                </label>
              </td>
              <td>
                <div>
                  <img src="../../../public/assets/images/shield1.png">
                </div>
              </td>
              <td class="text-center">
                <label class="text-center"  for="">
                  Almost Never
                </label>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </article>
      <article class="text-section table-section mt-5 mb-5">
        <label class="pt-4 text-center font-weight-bold blue-color w-100" for="">
          What Our Customers Say About Us:
        </label>
        <div class="row mt-4">
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">
            </div>
            <p class="review-wrapper">
              I have been an OREP customer for over five years, and these guys are fantastic. They have always gone ‘above and beyond’ with their service and are quick to respond to any concerns or
              needs I may have. I highly recommend them for your Insurance needs.<strong> Danny B.</strong>
            </p>
          </div>
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">
            </div>
            <p class="review-wrapper">
              Getting a quote was easy and OREP was able to provide comprehensive coverage for my inspection business, when other companies could not.<br><strong> Bob P.</strong>
            </p>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">
            </div>
            <p class="review-wrapper">
              I needed to get an insurance policy in place to renew my Home Inspection license. OREP completed the paperwork quickly and efficiently. Thank you.<br><strong> B. Doyle </strong>
            </p>
          </div>
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">
            </div>
            <p class="review-wrapper">
              Very easy to work with. I found them to have the most comprehensive coverage for the cost of coverage. They can cover WDI, Drone, Home Inspections and other services all at the same low
              price. I started with them when I first started inspecting, one of the few to offer new inspectors insurance. Highly recommend.<br><strong> Jon S.</strong>
            </p>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">
            </div>
            <p class="review-wrapper">
              I’ve been with OREP since I began and have no issues. If I call, I get to talk to a real live person! That’s important to me!<br> <strong>Jim K. </strong>
            </p>
          </div>
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">
            </div>
            <p class="review-wrapper">
              Competitive pricing, superior coverage. Although I do not envision needing heir claim support services, I sleep well knowing OREP has Sugarland Home Inspections, LLC well-covered.<br><strong>Kevin L.</strong>
            </p>
          </div>
        </div>
      </article>
      <article>
        <div v-if="isShowingRate" class="row pt-5 mb-5  input-section text-center">
          <h5 class="text-center mx-auto">
            <span class="blue-color2 pr-1"><span></span>{{ quickQuote.nameOfFirm }} <span></span></span><strong> Enjoy Coverage Beginning: </strong><span class="blue-color2">{{ formattedCurrentDate() }}</span>
          </h5>
        </div>
        <div v-if="isShowingRate" class="row mr-0 ml-0">
          <div class="col-md-7">
            <div class="text-center money-text pull-left">
              <p v-if="quickQuote.cyberCoverage" class="mr-0 representation-price-font-active" >{{ coverages[quickQuote.coverage].downCyberTotal }}</p>
              <p v-else class="mr-0 representation-price-font-active">{{ coverages[quickQuote.coverage].downTotal }}</p><span style="font-size:18px;top:-9px;position:relative;" class="blue-color">Down Payment</span>
              <br><span style="top:-22px;position:relative;font-size: 11px;" class="blue-color">Finance Your Policy- Finance Charge Applies</span>
            </div>
<!--            <button v-if="(this.quickQuote.customer.state === 'AR' || this.quickQuote.customer.state === 'CA' || this.quickQuote.customer.state === 'FL'-->
<!--            || this.quickQuote.customer.state === 'ND' || this.quickQuote.customer.state === 'WV' || this.quickQuote.customer.state === 'WY'-->
<!--            || this.quickQuote.customer.state === 'KS' || this.quickQuote.customer.state === 'NJ' || this.quickQuote.customer.state === 'NE'-->
<!--            || this.quickQuote.customer.state === 'WA' || this.quickQuote.customer.state === 'CT' || this.quickQuote.customer.state === 'MA'-->
<!--            || this.quickQuote.customer.state === 'OH' || this.quickQuote.customer.state === 'NY') && state.submittedSlDisclosure === false" class="pull-right pay-now"-->
<!--                    @click="formSubmit()">PAY NOW</button>-->
<!--            <a v-else class="pull-right pay-now_2"-->
<!--               v-bind:href="'https://orep.org/financeunited150/index.php?name='+quickQuote.nameOfPrincipalHomeInspector+'&ia_name='+quickQuote.nameOfFirm+'&address='+encodeURIComponent(quickQuote.customer.address)+'&city='+quickQuote.customer.city+'&state_code='+quickQuote.customer.state+'&zip='+quickQuote.customer.zipCode+'&phone='+quickQuote.customer.phone+'&email='+quickQuote.customer.email+'&date='+formattedCurrentDate()+'&premium='+total(coverages).toFixed(2)"-->
<!--               target="_blank">PAY NOW</a>-->
          </div>
          <div class="col-md-5 quote-includes-btn-wrapper flex align-items-center justify-content-md-center">
            <button
                class="orep-select quote-include_2"
                name="state"
                v-validate="'required'"
            >
              Quote Includes
            </button>
          </div>
        </div>
        <div v-if="isShowingRate" class="row quote-action quote-include_2-action-wrapper input-section mr-0 ml-0">
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title">E&O/GL PREMIUM:</span>
                <span v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberPremium }}</span>
                <span v-else >{{ coverages[quickQuote.coverage].premium }}</span>
              </li>
              <li>
                <span class="title"> {{ this.quickQuote.customer.state }} SL TAX:</span><span v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberSurplusLineTax }}</span>
                <span v-else >{{ coverages[quickQuote.coverage].surplusLineTax }}</span>
              </li>
              <li>
                <span class="title"> {{ this.quickQuote.customer.state }} SL STAMPING FEE:</span> <span v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberStampingFee }}</span>
                <span v-else >{{ coverages[quickQuote.coverage].stampingFee }}</span>
              </li>
              <li>
                <span class="title">OREP MEMBER FEE: </span>
                <span>{{ coverages[quickQuote.coverage].orepFee }}</span>
              </li>
              <li>
                <span class="title">ADDITIONAL STATE FEE:</span>
                <span v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberExtraFee }} </span>
                <span v-else >{{ coverages[quickQuote.coverage].extraFee }} </span>
              </li>
              <li class="total">
                <span class="title">TOTAL DUE:</span>
                <h5 class="font-weight-bold m-0" v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberTotal }}</h5>
                <h5 class="font-weight-bold m-0" v-else>{{ coverages[quickQuote.coverage].total }}</h5>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title_1">{{ coverages[quickQuote.coverage].orepClaim }} Personal Injury Coverage</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quickQuote.coverage].orepClaim }} General Liability Coverage(Per Claim)</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quickQuote.coverage].orepClaim }} Professional Liability -  Each Claim</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quickQuote.coverage].orepClaim }} Professional Liability - Aggregate Limit </span>
              </li>
              <li>
                <span class="title_1">$25,000 Disciplinary Proceedings</span>
              </li>
              <li>
                <span class="title_1">$5,000 Loss of Earnings</span>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="isShowingRate" class="row mr-0 ml-0">
          <div class="col-md-7">
            <div class="text-center money-text pull-left">
              <p class="representation-price-font-disable" v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberTotal }}</p>
              <p class="representation-price-font-disable" v-else>{{ coverages[quickQuote.coverage].total }}</p>
              <span style="font-size:17px;top:-10px;">Total - Pay in Full</span>
            </div>
<!--            <button v-if="(this.quickQuote.customer.state === 'AR' || this.quickQuote.customer.state === 'CA' || this.quickQuote.customer.state === 'FL'-->
<!--            || this.quickQuote.customer.state === 'ND' || this.quickQuote.customer.state === 'WV' || this.quickQuote.customer.state === 'WY'-->
<!--            || this.quickQuote.customer.state === 'KS' || this.quickQuote.customer.state === 'NJ' || this.quickQuote.customer.state === 'NE'-->
<!--            || this.quickQuote.customer.state === 'WA' || this.quickQuote.customer.state === 'CT' || this.quickQuote.customer.state === 'MA'-->
<!--            || this.quickQuote.customer.state === 'OH' || this.quickQuote.customer.state === 'NY') && state.submittedSlDisclosure === false"-->
<!--                    class="pull-right pay-now_3"-->
<!--                    @click="formSubmit()">PAY NOW</button>-->
<!--            <button v-else-->
<!--                    class="pull-right pay-now_3"-->
<!--                    @click="navigateToNext('property-inspector-payment')">PAY NOW</button>-->

          </div>
          <div class="col-md-5 quote-includes-btn-wrapper flex align-items-center justify-content-md-center">
            <button
                class="orep-select quote-include_3"
                name="state"
                v-validate="'required'"
            >
              Quote Includes
            </button>
          </div>
        </div>
        <div v-if="isShowingRate" class="row quote-action quote-include_3-action-wrapper input-section mr-0 ml-0">
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title">E&O/GL PREMIUM:</span>
                <span v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberPremium }}</span>
                <span v-else >{{ coverages[quickQuote.coverage].premium }}</span>
              </li>
              <li>
                <span class="title"> {{ this.quickQuote.customer.state }} SL TAX:</span><span v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberSurplusLineTax }}</span>
                <span v-else >{{ coverages[quickQuote.coverage].surplusLineTax }}</span>
              </li>
              <li>
                <span class="title"> {{ this.quickQuote.customer.state }} SL STAMPING FEE:</span> <span v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberStampingFee }}</span>
                <span v-else >{{ coverages[quickQuote.coverage].stampingFee }}</span>
              </li>
              <li>
                <span class="title">OREP MEMBER FEE: </span>
                <span>{{ coverages[quickQuote.coverage].orepFee }}</span>
              </li>
              <li>
                <span class="title">ADDITIONAL STATE FEE:</span>
                <span v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberExtraFee }} </span>
                <span v-else >{{ coverages[quickQuote.coverage].extraFee }} </span>
              </li>
              <li class="total">
                <span class="title">TOTAL DUE:</span>
                <h5 class="font-weight-bold m-0" v-if="quickQuote.cyberCoverage" >{{ coverages[quickQuote.coverage].cyberTotal }}</h5>
                <h5 class="font-weight-bold m-0" v-else>{{ coverages[quickQuote.coverage].total }}</h5>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title_1">{{ coverages[quickQuote.coverage].orepClaim }} Personal Injury Coverage</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quickQuote.coverage].orepClaim }} General Liability Coverage(Per Claim)</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quickQuote.coverage].orepClaim }} Professional Liability -  Each Claim</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quickQuote.coverage].orepClaim }} Professional Liability - Aggregate Limit </span>
              </li>
              <li>
                <span class="title_1">$25,000 Disciplinary Proceedings</span>
              </li>
              <li>
                <span class="title_1">$5,000 Loss of Earnings</span>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="getApplicantType === 'spmga'" class="row pt-5 mb-5 input-section footer-wrapper ml-0 mr-0">
          <h2 class="text-center mx-auto">
            <strong>Questions?</strong> Chat, <a href = "mailto:christy@orep.org">Email</a>, or Call Now (281) 674-7146.
          </h2>
        </div>
        <div v-else class="row pt-5 mb-5 input-section footer-wrapper ml-0 mr-0">
          <h2 class="text-center mx-auto">
            <strong>Questions?</strong> Chat, <a href = "mailto:inspectors@OREP.org">Email</a>, or Call Now (888) 347-5273.
          </h2>
        </div>
      </article>
    </section>
  </div>
</template>
<script>
import $ from "jquery";
import {APP_STATUS, STATES, STATUS} from "../../utils/constants";
import moment from "moment";

export default {
  name: 'property-inspector-representation',
  computed: {
    quickQuote() {
      return this.$store.state.quickQuote.quickQuote;
    },
    coverages() {
      return this.$store.state.quickQuote.coverages;
    },
    state() {
      return this.$store.state.quickQuote;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/quick-quote-amba' || first === '/portal/quick-quote-amba/' || this.quickQuote.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (first === '/portal/quick-quote-realshield' || first === '/portal/quick-quote-realshield/' || this.quickQuote.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }
      else if (first === '/portal/quick-quote-spmga' || first === '/portal/quick-quote-spmga/' || this.quickQuote.customer.partnerName === 'spmga'){
        return 'spmga';
      }
      else {
        return 'OREP';
      }
    },

    isShowingRate() {
      return !(this.quickQuote.expectedAnnualRevenue > 150000 ||
          this.quickQuote.memberOfLicensedProfessional === 'no' ||
          this.quickQuote.anyClaimsInLastFiveYears === 'true' ||
          this.quickQuote.customer.state === 'HI' ||
          this.quickQuote.customer.state === 'AK'
          || this.quickQuote.customer.state === 'KY');
    },
    isShowingUnderneathText() {
      return this.quickQuote.singleClientProvidesMt25PercentRevenue === 'true' ||
          this.quickQuote.applicantExclusiveToAnyCompany === 'true' ||
          this.quickQuote.providesOtherServices === 'true' ||
          this.quickQuote.applicantOrAssociateProvidesOtherServices === 'true' ||
          this.quickQuote.enteredLimitedLiabilityContract === 'true' ||
          this.quickQuote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true' ||
          this.quickQuote.isPreInspectionAgreementAlwaysSigned === 'false' ||
          this.quickQuote.applicantTakesDigitalPhotosOfInspections === 'false' ||
          this.quickQuote.isThereAMethodToAuthenticatePhotoDatetime === 'false' ||
          this.quickQuote.applicantTakesContinuingTrainingYearly === 'false' ||
          this.quickQuote.averageOfMoreThan3InspectionsPerDayPerInspector === 'true';
    },
    deductibleAmount() {

      return ((this.quickQuote.homeInspectingExperience === '3-to-7' ||
              this.quickQuote.homeInspectingExperience === '3-to-7' ) &&
          this.quickQuote.anyClaimsInLastFiveYears === 'false' &&
          this.quickQuote.doYouUseLimitationOfLiability === 'true' &&
          this.quickQuote.expectedAnnualRevenue <= 150000);
    }
  },
  methods: {
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    slDisclosure(){
      return true;
    },
    slDisclosure_test(){
      if (this.quickQuote.customer.state === 'AR' || this.quickQuote.customer.state === 'CA' || this.quickQuote.customer.state === 'FL'
          || this.quickQuote.customer.state === 'ND' || this.quickQuote.customer.state === 'WV' || this.quickQuote.customer.state === 'WY'
          || this.quickQuote.customer.state === 'KS' || this.quickQuote.customer.state === 'NJ' || this.quickQuote.customer.state === 'NE'
          || this.quickQuote.customer.state === 'WA' || this.quickQuote.customer.state === 'CT' || this.quickQuote.customer.state === 'MA'
          || this.quickQuote.customer.state === 'OH' || this.quickQuote.customer.state === 'NY'){
        return true;
      }
      else {
        return false;
      }
    },
    formSubmit() {
      this.loading = true;
      this.quickQuote.status = STATUS.Submitted;
      this.quickQuote.customer.appStatus = APP_STATUS.Completed;
      this.$store.dispatch('homeInspector/createFormalQuote');
    },
    isSlDisclosureSubmitted() {
      return false;
    },
    dollarSlicing(sclicingValue) {
      return sclicingValue.slice(1);
    },
    formattedCurrentDate() {
      return moment.utc(this.quickQuote.applicantPrincipleEsignatureDatetime).format('MM/DD/YYYY');
    },
    getEffectiveDate() {
      return moment.utc(this.state.quickQuote.effectiveDate).format('MM/DD/YYYY');
    },
    total(coverages) {
      if (this.quickQuote.cyberCoverage){
        return parseFloat((coverages[this.quickQuote.coverage].cyberPremium).slice(1).replace(',','')) + parseFloat((coverages[this.quickQuote.coverage].cyberSurplusLineTax).slice(1)) + parseFloat((coverages[this.quickQuote.coverage].cyberStampingFee).slice(1)) + parseFloat((coverages[this.quickQuote.coverage].cyberExtraFee).slice(1));
      }
      else {
        return parseFloat((coverages[this.quickQuote.coverage].premium).slice(1).replace(',','')) + parseFloat((coverages[this.quickQuote.coverage].surplusLineTax).slice(1)) + parseFloat((coverages[this.quickQuote.coverage].stampingFee).slice(1)) + parseFloat((coverages[this.quickQuote.coverage].extraFee).slice(1));

      }
    },
    down_total(coverages) {
      if (this.quickQuote.cyberCoverage){
        return coverages[this.quickQuote.coverage].downCyberTotal;
      }
      else {
        return coverages[this.quickQuote.coverage].downTotal;
      }
    },
  },
  mounted: function() {
    $(".orep-select.quote-include").click(function(){
      if($(this).hasClass("active")){
        $(this).removeClass("active");
        $(".quote-include-action-wrapper").css("padding-top", "0px");
        $(".quote-include-action-wrapper").css("height", "0px");
        $(".quote-include-action-wrapper").css("opacity", "0");
      }else{
        $(this).addClass("active");
        $(".quote-include-action-wrapper").css("padding-top", "40px");
        $(".quote-include-action-wrapper").css("height", "330px");
        $(".quote-include-action-wrapper").css("opacity", "1");
      }
    }),
        $(".orep-select.quote-include_1").click(function(){
          if($(this).hasClass("active")){
            $(this).removeClass("active");
            $(".quote-include_1-action-wrapper").css("padding-top", "0px");
            $(".quote-include_1-action-wrapper").css("height", "0px");
            $(".quote-include_1-action-wrapper").css("opacity", "0");
          }else{
            $(this).addClass("active");
            $(".quote-include_1-action-wrapper").css("padding-top", "40px");
            $(".quote-include_1-action-wrapper").css("height", "330px");
            $(".quote-include_1-action-wrapper").css("opacity", "1");
          }
        }),
        $(".orep-select.quote-include_2").click(function(){
          console.log(33333);
          if($(this).hasClass("active")){
            $(this).removeClass("active");
            $(".quote-include_2-action-wrapper").css("padding-top", "0px");
            $(".quote-include_2-action-wrapper").css("height", "0px");
            $(".quote-include_2-action-wrapper").css("opacity", "0");
          }else{
            $(this).addClass("active");
            $(".quote-include_2-action-wrapper").css("padding-top", "40px");
            $(".quote-include_2-action-wrapper").css("height", "330px");
            $(".quote-include_2-action-wrapper").css("opacity", "1");
          }
        }),
        $(".orep-select.quote-include_3").click(function(){
          if($(this).hasClass("active")){
            $(this).removeClass("active");
            $(".quote-include_3-action-wrapper").css("padding-top", "0px");
            $(".quote-include_3-action-wrapper").css("height", "0px");
            $(".quote-include_3-action-wrapper").css("opacity", "0");
          }else{
            $(this).addClass("active");
            $(".quote-include_3-action-wrapper").css("padding-top", "40px");
            $(".quote-include_3-action-wrapper").css("height", "330px");
            $(".quote-include_3-action-wrapper").css("opacity", "1");
          }
        }),
        $('html, body').animate({
          scrollTop: $('.representation-container').offset().top
        }, 500);
  },
}
</script>